<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="提交"
      :submit-loading="submitLoading"
      @submit="submitConfirm"
      @cancel="handleToPrimaryKeyList">
      <div slot="content">
        <lk-card>
          <lk-form
            ref="form"
            label-position="right"
            :label-width="134">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="商品列表:">
                  <lk-button type="primary" @click="handleAdd">新增</lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="">
                  <div class="goodsPrimaryKeyAdd" :class="['approvedNames', 'approvalNumber', 'specifications']">
                    <lk-table border :columns="columns" :data="tableData"></lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <DTPModal
      v-model="submitConfirmVisiable"
      content="商品主键被修改，确认提交？"
      :confirmLoading="submitLoading"
      @confirm="submit"
      @handleCancel="submitConfirmVisiable = false">
    </DTPModal>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="选择商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <goodsSearchItem v-model="modalQuery.nameMix" placeholder='支持商品编码、通用名、商品名'></goodsSearchItem>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <LoadingSpan v-show="modalLoading"></LoadingSpan>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="modalPage.count"
          :page-size="modalPage.size"
          :current="modalPage.page"
          size="small"
          show-sizer
          show-total
          show-elevator
          @on-change="handleModalPage"
          @on-page-size-change="handleModalSize">
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempSelection.length + this.tableData.length}}项</span>
          <lk-button @click="hideModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushModalData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
// import supplier from '../../services/supplier';
import goodsService from '../../services/goods';
import utils from '../../libs/utils';
import DTPModal from '../../components/DTPModal';
import LoadingSpan from '../../components/LoadingSpan.vue';
import goodsTypeCascader from '../../components/goodsTypeCascader.vue';

export default {
  name: 'goodsPrimaryKeyAdd',
  components: {
    baseFrame,
    DTPModal,
    LoadingSpan,
  },
  data() {
    return {
      approvalNumberTypeArr: [
        '国药准字',
        '进口注册证号',
        '医药产品注册证',
        '国药试字',
      ],
      submitConfirmVisiable: false,
      submitLoading: false,
      tableData: [],
      columns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        {
          title: '商品通用名',
          key: 'approvedDrugNames',
          minWidth: 130,
          render: (h, { row, index }) => {
            if (row.type !== 1 && row.type !== 2) {
              return h('lk-input', {
                props: {
                  // clearable: true,
                  value: row.approvedDrugNames,
                  maxlength: 100,
                  placeholder: '请输入',
                },
                on: {
                  'on-blur': (e) => {
                    const value = e.target.value;
                    row.approvedDrugNames = value;
                    this.tableData[index].approvedDrugNames = value;
                  },
                },
              });
            }
            return h('span', row.approvedDrugNames);
          },
        },
        {
          title: '商品类型',
          key: 'type',
          minWidth: 116,
          render: (h, { row, index }) => {
            const optionArr = this.goodsTypes.map(item => h('lk-option', {
              props: {
                value: item.value,
              },
            }, item.name));
            // return h('lk-select',
            return h(goodsTypeCascader,
              {
                props: {
                  value: row.type,
                  transfer: true,
                  placeholder: '请选择',
                },
                on: {
                  'on-change': (value) => {
                    // 一旦切换类型，将数据还原，避免多次切换既可以修改"商品通用名"和"批准文号/注册证号"
                    const item = this.tableData[index];
                    item.type = value;
                    item.approvedDrugNames = item.old.approvedDrugNames;
                    item.approvalNumber = item.old.approvalNumber;
                    item.approvalNumberType = item.old.approvalNumberType;
                    item.specifications = item.old.specifications;
                    item.manufacturer = item.old.manufacturer;
                    item.countryOfOrigin = item.old.countryOfOrigin;
                  },
                },
              },
              optionArr);
          },
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
          render: (h, { row, index }) => h('lk-input', {
            props: {
              value: row.specifications,
              placeholder: '请输入',
            },
            on: {
              'on-blur': (e) => {
                const specifications = e.target.value;
                row.specifications = specifications;
                this.tableData[index].specifications = specifications;
              },
            },
          }),
        },
        {
          title: '批准文号/注册证号',
          minWidth: 260,
          render: (h, { row, index }) => {
            if (row.type === 1 || row.type === 2) {
              const optionArr = this.approvalNumberTypeArr.map(item => h('lk-option', {
                props: {
                  value: item,
                },
              }, item));
              return h('div', {
                style: {
                  display: 'flex',
                },
              }, [
                row.type === 1 ? h('lk-select',
                  {
                    props: {
                      value: row.approvalNumberType,
                      transfer: true,
                    },
                    style: {
                      marginRight: '10px',
                      flex: '0 1 auto',
                    },
                    on: {
                      'on-change': (value) => {
                        this.tableData[index].approvalNumberType = value;
                      },
                    },
                  },
                  optionArr) : null,
                h('lk-input', {
                  props: {
                    // clearable: true,
                    value: row.approvalNumber,
                    placeholder: '请输入',
                  },
                  on: {
                    'on-blur': (e) => {
                      const approvalNumber = e.target.value;
                      row.approvalNumber = approvalNumber;
                      this.tableData[index].approvalNumber = approvalNumber;
                    },
                  },
                }),
              ]);
            }

            return h('span', row.approvalNumberType + row.approvalNumber);
          },
        },
        {
          title: '生产企业',
          key: 'manufacturer',
          minWidth: 116,
          render: (h, { row, index }) => {
          	if (row.type > 2) {
              return h('lk-input', {
                props: {
                  value: row.manufacturer,
                  placeholder: '请输入',
                },
                on: {
                  'on-blur': (e) => {
                    const manufacturer = e.target.value;
                    row.manufacturer = manufacturer;
                    this.tableData[index].manufacturer = manufacturer;
                  },
                },
              });
            }
          	return h('span', row.manufacturer);
          },
        },
        {
          title: '产地',
          key: 'countryOfOrigin',
          minWidth: 116,
          render: (h, { row, index }) => {
            if (row.type === 3) {
              return h('lk-input', {
                props: {
                  value: row.countryOfOrigin,
                  placeholder: '请输入',
                },
                on: {
                  'on-blur': (e) => {
                    const countryOfOrigin = e.target.value;
                    row.countryOfOrigin = countryOfOrigin;
                    this.tableData[index].countryOfOrigin = countryOfOrigin;
                  },
                },
              });
            }
            return h('span', row.countryOfOrigin);
          },
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnitString',
          minWidth: 116,
        },
        {
          title: '剂型',
          key: 'dosageFormString',
          minWidth: 116,
        },
        { title: '商品名称', key: 'goodsName', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.tableData.splice(index, 1);
                this.$Message.success('删除成功');
              },
            },
          }, '删除'),
        },
      ],
      isImportArr: ['', '是', '否'],
      modalLoading: false,
      modalVisiable: false,
      modalQuery: {
        nameMix: null,
      },
      modalParams: {},
      modalPage: {
        page: 1,
        size: 10,
        count: 0,
      },
      tempSelection: [],
      modalTableData: [],
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '药品通用名', key: 'approvedDrugNames', minWidth: 156 },
        { title: '商品类型', key: 'typeString', minWidth: 156 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 186 },
        { title: '批准文号/注册证号', key: 'approvalNumberStr', minWidth: 166 },
        { title: '剂型', key: 'dosageFormString', minWidth: 116 },
        { title: '药品最小包装单位', key: 'drugMiniPackageUnitString', minWidth: 166 },
        { title: '储存条件', key: 'storageConditionsString', minWidth: 116 },
        { title: '本位码', key: 'ndcNumber', minWidth: 116 },
        { title: '产地', key: 'countryOfOrigin', minWidth: 116 },
        { title: '质检标准', key: 'drugAcceptanceStandard', minWidth: 116 },
        { title: '批件号', key: 'drugRegApprovalCode', minWidth: 166 },
        { title: '批件有效期', key: 'periodDrugRegApproval', minWidth: 166 },
        { title: '商品名称', key: 'goodsName', minWidth: 116 },
        { title: '化学成分', key: 'chemicalComposition', minWidth: 116 },
        { title: '条形码', key: 'barCode', minWidth: 116 },
        { title: '是否进口', key: 'isImport', minWidth: 116 },
        {
          title: '商品标签', key: 'goodsLabelsString', minWidth: 156, tooltip: true,
        },
        { title: '商品分类', key: 'indicationDicString', minWidth: 156 },
        {
          title: '状态',
          minWidth: 116,
          key: 'baseInfoStatus',
          render: (h, { row }) => h('span', row.goodsBaseStatus === 1 ? '启用' : '禁用'),
        },
      ],
    };
  },
  computed: {
    goodsTypes() {
      // return this.$store.state.publicParams.purchaseGoodsTypes;
      return this.$store.state.publicParams.goodsTypes;
    },
    selectedIds() {
      const result = [];
      this.tableData.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
    tempSelectionIds() {
      const result = [];
      this.tempSelection.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
  },
  methods: {
    handleToPrimaryKeyList() {
      this.$router.push({
        name: 'goodsPrimaryKey',
      });
    },
    getModalData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      this.modalTableData = [];
      goodsService.listGoodsBases(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item.goodsBase, result);
            result.goodsBaseId = result.id;
            result.originGoodsBaseId = result.id;
            if (item.type === 1 || item.type === 2) { // 药品和医疗器械  = 批准文号 + 注册证号 + 包装规格
              result.id = result.approvalNumber + result.specifications;
            } else if (item.type === 3) { // 中药饮片 = 通用名 + 规格 + 生产企业 + 产地
              result.id = result.approvedDrugNames + result.specifications + result.manufacturer + result.countryOfOrigin;
            } else { // 其他 = 通用名 + 规格 + 生产企业
              result.id = result.approvedDrugNames + result.specifications + result.manufacturer;
            }
            result.id += result.goodsBaseId;
            result.drugRegApprovalCode = item.goodsBase.drugRegApprovalCode || item.goodsBase.importRegCertCode;
            result.periodDrugRegApproval = utils.exchangeTime(item.goodsBase.periodDrugRegApproval || item.goodsBase.periodImportRegCert);
            result.drugMiniPackageUnitString = item.drugMiniPackageUnitString;
            result.storageConditionsString = item.storageConditionsString;
            result.dosageFormString = item.dosageFormString;
            result.goodsLabelsString = item.goodsLabelsString;
            result.isImport = this.isImportArr[item.goodsBase.isImport];
            if (item.indicationDicString) {
              const regExp = new RegExp(',', 'g');
              result.indicationDicString = item.indicationDicString.replace(regExp, '/');
            }
            result.typeString = utils.handleGoodsTypeStr(item.goodsBase.type);
            const { approvalNumber, approvalNumberType } = this.handleGoodsApprovalType(this.approvalNumberTypeArr, item.goodsBase.approvalNumber);
            result.approvalNumberStr = item.goodsBase.approvalNumber;
            result.approvalNumber = approvalNumber;
            result.approvalNumberType = approvalNumberType;
            result.old = {
              approvedDrugNames: result.approvedDrugNames,
              type: result.type,
              approvalNumber: result.approvalNumber,
              approvalNumberType: result.approvalNumberType,
              specifications: result.specifications,
              manufacturer: result.manufacturer,
              countryOfOrigin: result.countryOfOrigin,
            };
            result._checked = this.selectedIds.includes(result.id) || this.tempSelectionIds.includes(result.id);
            result._disabled = this.selectedIds.includes(result.id);
            this.modalTableData.push(result);
          });
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },

    validatorItem(item) {
      const approvedDrugNames = item.approvedDrugNames;
      const approvalNumberType = item.approvalNumberType;
      const approvalNumber = item.approvalNumber;
      const specifications = item.specifications;
      const manufacturer = item.manufacturer;
      const countryOfOrigin = item.countryOfOrigin;
      return new Promise((resolve) => {
        const result = {
          type: 2, // 1为通过 2为失败
          message: '',
        };
        if (utils.isEmpty(item.type)) {
          result.message = `商品编码${item.drugSerialCode}的商品类型不能为空`;
          resolve(result);
          return;
        }
        if (utils.isEmpty(specifications)) {
          result.message = `商品编码${item.drugSerialCode}的规格不能为空`;
          resolve(result);
          return;
        }
        if (item.type === 1 && utils.isEmpty(approvalNumberType)) {
          result.message = `商品编码${item.drugSerialCode}的批准文号不能为空`;
          resolve(result);
          return;
        }
        if (item.type > 2) {
        	if (utils.isEmpty(approvedDrugNames)) {
            result.message = `商品编码${item.drugSerialCode}的商品通用名不能为空`;
            resolve(result);
            return;
          }
          if (utils.isEmpty(manufacturer)) {
            result.message = `商品编码${item.drugSerialCode}的生产企业不能为空`;
            resolve(result);
            return;
          }
        }
        if (item.type < 3) {
          if (utils.isEmpty(approvalNumber)) {
            result.message = `商品编码${item.drugSerialCode}的注册证号不能为空`;
            resolve(result);
            return;
          }
          if(item.type !== 2) {
            if (!/^([A-Z]){1,3}\d{8}$/.test(approvalNumber)) {
              result.message = `商品编码${item.drugSerialCode}的注册证号格式不正确`;
              resolve(result);
            }
          }
          
        }
        if (item.type === 3 && utils.isEmpty(countryOfOrigin)) {
          result.message = `商品编码${item.drugSerialCode}的产地不能为空`;
          resolve(result);
          return;
        }

        // 检测重复数据
        const uniqValue = this.getUniqueValue(item);
        const reduplicateList = [];
        this.tableData.forEach((subItem) => {
          if (item.type === subItem.type) {
            const subItemValue = this.getUniqueValue(subItem);
            if (uniqValue === subItemValue) {
              reduplicateList.push(subItem.drugSerialCode);
            }
          }
        });

        const originValue = this.getUniqueValue(item.old);
        if (reduplicateList.length > 1) {
          result.message = `商品编码${reduplicateList.join('、')}主键重复`;
          resolve(result);
        } else if (uniqValue === originValue) {
          result.message = `商品编码${item.drugSerialCode}未做任何更改，无需提交`;
          resolve(result);
        } else {
          this.$store.commit('setDisableLoading', true);
          const params = {
            type: item.type, // 商品类型
            specifications: item.specifications, // 规格
          };

          if (item.type === 1) { // 药品  = 批准文号 + 注册证号 + 包装规格
            params.approvalNumber = item.approvalNumberType + item.approvalNumber;
          } else if (item.type === 2) { // 医疗器械 =  注册证号 + 包装规格
            params.approvalNumber = item.approvalNumber;
          } else if (item.type === 3) { // 中药饮片 = 通用名 + 规格 + 生产企业 + 产地
            params.approvedDrugNames = item.approvedDrugNames;
            params.manufacturer = item.manufacturer;
            params.countryOfOrigin = item.countryOfOrigin;
          } else { // 其他 = 名称 + 规格 + 生产企业
            params.approvedDrugNames = item.approvedDrugNames;
            params.manufacturer = item.manufacturer;
          }

          // 服务器端判重
          goodsService.existsGoodsBase(params).then((res) => {
            if (res.data.status === 200) {
              if (res.data.data) {
                result.message = `商品编码${item.drugSerialCode}唯一键与已存在商品重复，请使用商品合并工具`;
                resolve(result);
              } else {
                result.message = '';
                result.type = 1;
                resolve(result);
              }
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    getUniqueValue(item) {
      let result = '';
      switch (item.type) {
        case 1: // // 药品  = 批准文号 + 注册证号 + 包装规格
          result = item.approvalNumberType + item.approvalNumber + item.specifications;
          break;
        case 2: // 医疗器械 =  注册证号 + 包装规格
          result = item.approvalNumber + item.specifications;
          break;
        case 3: // 中药饮片 = 通用名 + 规格 + 生产企业 + 产地
          result = item.approvedDrugNames + item.specifications + item.manufacturer + item.countryOfOrigin;
          break;
        default: // 其他 = 名称 + 规格 + 生产企业
          result = item.approvedDrugNames + item.specifications + item.manufacturer;
          break;
      }
      return result + item.type; // 增加类型
    },
    submit() {
      const params = [];
      this.tableData.forEach((item) => {
        const approvalCode = item.type === 2 ? item.approvalNumber : item.approvalNumberType + item.approvalNumber;
        params.push({
          goodsBaseId: item.originGoodsBaseId,
          serialCode: item.drugSerialCode,
          approvedName: item.approvedDrugNames,
          approvalCode,
          spec: item.specifications,
          producer: item.manufacturer,
          origin: item.countryOfOrigin,
          goodsType: item.type,
        });
      });
      this.submitLoading = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.goodsPrimarySubmit({ operateGoodsKeyVoList: params }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToPrimaryKeyList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submitConfirm() {
      if (this.tableData.length === 0) {
        this.$Message.error('请先添加商品');
        return;
      }

      const promiseList = [];
      this.tableData.forEach((item) => {
        promiseList.push(this.validatorItem(item));
      });

      Promise.all(promiseList).then((res) => {
        if (res.every(item => item.type === 1)) {
          this.submitConfirmVisiable = true;
        } else {
          for (let i = 0, len = res.length; i < len; i++) {
            const item = res[i];
            if (item.type === 2) {
              this.$Message.error(item.message);
              // break;
            }
          }
        }
      });
    },
    clearModalQuery() {
      this.modalQuery = {};
    },
    hideModal() {
      this.modalVisiable = false;
    },
    handleAdd() {
      this.modalVisiable = true;
      this.clearModalQuery();
      this.handleModalSearch();
    },
    handleModalSearch() {
      this.tempSelection = [];
      this.modalPage.page = 1;
      this.modalPage.size = 10;
      this.modalParams = utils.deepClone(this.modalQuery);
      this.getModalData();
    },
    pushModalData() {
      if (this.tempSelection.length === 0 && this.tableData.length === 0) {
        this.$Message.error('请选择记录');
        return;
      }

      if (this.tempSelection.length > 10) {
        this.$store.commit('setLoading', true);
        utils.timeChunk(this.tempSelection, (goods) => {
          this.tableData.push(goods);
        }, 10, () => {
          this.$store.commit('setLoading', false);
        })();
      } else {
        this.tempSelection.forEach((item) => {
          this.tableData.push(item);
        });
      }
      this.tempSelection = [];
      this.hideModal();
    },
    handleModalPage(val) {
      this.modalPage.page = val;
      this.getModalData();
    },
    handleModalSize(val) {
      this.modalPage.size = val;
      this.getModalData();
    },
    handleTempSelect(selection, row) {
      if (!this.tempSelectionIds.includes(row.id)) {
        this.tempSelection.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempSelection.forEach((item, index) => {
        if (item.id === row.id) {
          this.tempSelection.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.tempSelectionIds.includes(item.id) && !this.selectedIds.includes(item.id)) {
          this.tempSelection.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.modalTableData.forEach((good) => {
        for (let i = 0, len = this.tempSelection.length; i < len; i++) {
          if (this.tempSelection[i].id === good.id) {
            this.tempSelection.splice(i, 1);
            break;
          }
        }
      });
    },
    handleGoodsApprovalType(typesList, value) {
      let typeStr = '';
      let result = value;

      typesList.forEach((str) => {
        value.includes(str) && (typeStr = str);
      });
      result = result.replace(typeStr, '');

      return {
        approvalNumber: result,
        approvalNumberType: typeStr,
      };
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
</style>
